import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-2fdabf10.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import( /* webpackChunkName: "storm-ui--CloseButton--ar-AE" */'./ar-AE-7758ae5b.js'),
  'de-DE': () => import( /* webpackChunkName: "storm-ui--CloseButton--de-DE" */'./de-DE-6d29a759.js'),
  'en-AU': () => import( /* webpackChunkName: "storm-ui--CloseButton--en-AU" */'./en-AU-dbd6a161.js'),
  'en-CA': () => import( /* webpackChunkName: "storm-ui--CloseButton--en-CA" */'./en-CA-4abe5fcb.js'),
  'en-GB': () => import( /* webpackChunkName: "storm-ui--CloseButton--en-GB" */'./en-GB-0f7c85c4.js'),
  'en-IN': () => import( /* webpackChunkName: "storm-ui--CloseButton--en-IN" */'./en-IN-bbbbc204.js'),
  'en-SG': () => import( /* webpackChunkName: "storm-ui--CloseButton--en-SG" */'./en-SG-a64bfe59.js'),
  'es-CO': () => import( /* webpackChunkName: "storm-ui--CloseButton--es-CO" */'./es-CO-a806cb82.js'),
  'es-ES': () => import( /* webpackChunkName: "storm-ui--CloseButton--es-ES" */'./es-ES-042c561f.js'),
  'es-MX': () => import( /* webpackChunkName: "storm-ui--CloseButton--es-MX" */'./es-MX-ab73e8a5.js'),
  'es-US': () => import( /* webpackChunkName: "storm-ui--CloseButton--es-US" */'./es-US-fc9bff73.js'),
  'fr-CA': () => import( /* webpackChunkName: "storm-ui--CloseButton--fr-CA" */'./fr-CA-91152688.js'),
  'fr-FR': () => import( /* webpackChunkName: "storm-ui--CloseButton--fr-FR" */'./fr-FR-80d430c7.js'),
  'hi-IN': () => import( /* webpackChunkName: "storm-ui--CloseButton--hi-IN" */'./hi-IN-f466fbb2.js'),
  'it-IT': () => import( /* webpackChunkName: "storm-ui--CloseButton--it-IT" */'./it-IT-dac24c16.js'),
  'ja-JP': () => import( /* webpackChunkName: "storm-ui--CloseButton--ja-JP" */'./ja-JP-38b4a59f.js'),
  'ko-KR': () => import( /* webpackChunkName: "storm-ui--CloseButton--ko-KR" */'./ko-KR-efad7eec.js'),
  'nl-NL': () => import( /* webpackChunkName: "storm-ui--CloseButton--nl-NL" */'./nl-NL-63790ee8.js'),
  'pl-PL': () => import( /* webpackChunkName: "storm-ui--CloseButton--pl-PL" */'./pl-PL-eb84e5e9.js'),
  'pt-BR': () => import( /* webpackChunkName: "storm-ui--CloseButton--pt-BR" */'./pt-BR-c3954522.js'),
  'sv-SE': () => import( /* webpackChunkName: "storm-ui--CloseButton--sv-SE" */'./sv-SE-60808b9c.js'),
  'ta-IN': () => import( /* webpackChunkName: "storm-ui--CloseButton--ta-IN" */'./ta-IN-6b9283aa.js'),
  'th-TH': () => import( /* webpackChunkName: "storm-ui--CloseButton--th-TH" */'./th-TH-bc3ab995.js'),
  'tr-TR': () => import( /* webpackChunkName: "storm-ui--CloseButton--tr-TR" */'./tr-TR-cc9ce063.js'),
  'vi-VN': () => import( /* webpackChunkName: "storm-ui--CloseButton--vi-VN" */'./vi-VN-c4b45126.js'),
  'zh-CN': () => import( /* webpackChunkName: "storm-ui--CloseButton--zh-CN" */'./zh-CN-9d38a47b.js'),
  'zh-TW': () => import( /* webpackChunkName: "storm-ui--CloseButton--zh-TW" */'./zh-TW-e8014088.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-07819368.js.map
